import type { ReactNode } from 'react';

import { ToggleLeftIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

type CustomInsightBooleanCardProps = {
  label: string;
  /**
   * Display value, e.g. "68%". Kept as a pre-formatted string so callers can use locale-specific rules.
   */
  valueLabel: string;
  className?: string;
  /** Optional trend indicator rendered under the value (compare-mode). */
  comparison?: ReactNode;
};

/**
 * Metric card for boolean custom insight fields, showing a single share (Figma: boolean metrics).
 */
export const CustomInsightBooleanCard = ({
  label,
  valueLabel,
  className,
  comparison,
}: CustomInsightBooleanCardProps) => {
  return (
    <div
      className={cn(
        'relative flex max-w-96 min-w-60 flex-1 items-center overflow-hidden rounded-lg border border-stroke bg-background p-4',
        className
      )}
    >
      <div className="flex min-w-0 flex-1 flex-col gap-4">
        <p className="text-xs leading-4 font-medium whitespace-nowrap text-foreground-muted">
          {label}
        </p>
        <div className="flex flex-col items-start justify-end gap-1">
          <p className="text-2xl leading-none font-semibold tracking-tight whitespace-nowrap text-foreground">
            {valueLabel}
          </p>
          {comparison}
        </div>
      </div>
      <div
        className="pointer-events-none absolute top-1/2 -right-[21px] size-24 -translate-y-1/2 opacity-40"
        aria-hidden
      >
        <ToggleLeftIcon className="size-24 text-stroke" strokeWidth={1.5} />
      </div>
    </div>
  );
};
